{
  "REPORT": {
    "HEADER": "Konversationer",
    "LOADING_CHART": "Laddar diagramdata...",
    "NO_ENOUGH_DATA": "Vi har inte fått tillräckligt många datapunkter för att generera en rapport, försök igen senare.",
    "DOWNLOAD_AGENT_REPORTS": "Ladda ner agentrapporter",
    "DATA_FETCHING_FAILED": "Failed to fetch data, please try again later.",
    "SUMMARY_FETCHING_FAILED": "Failed to fetch summary, please try again later.",
    "METRICS": {
      "CONVERSATIONS": {
        "NAME": "Konversationer",
        "DESC": "( Totalt )"
      },
      "INCOMING_MESSAGES": {
        "NAME": "Inkommande meddelanden",
        "DESC": "( Totalt )"
      },
      "OUTGOING_MESSAGES": {
        "NAME": "Utgående meddelanden",
        "DESC": "( Totalt )"
      },
      "FIRST_RESPONSE_TIME": {
        "NAME": "First Response Time",
        "DESC": "( Genomsnitt )",
        "INFO_TEXT": "Total number of conversations used for computation:",
        "TOOLTIP_TEXT": "First Response Time is {metricValue} (based on {conversationCount} conversations)"
      },
      "RESOLUTION_TIME": {
        "NAME": "Lösningstid",
        "DESC": "( Genomsnitt )",
        "INFO_TEXT": "Total number of conversations used for computation:",
        "TOOLTIP_TEXT": "Resolution Time is {metricValue} (based on {conversationCount} conversations)"
      },
      "RESOLUTION_COUNT": {
        "NAME": "Antal lösta",
        "DESC": "( Totalt )"
      },
      "BOT_RESOLUTION_COUNT": {
        "NAME": "Antal lösta",
        "DESC": "( Totalt )"
      },
      "BOT_HANDOFF_COUNT": {
        "NAME": "Handoff Count",
        "DESC": "( Totalt )"
      },
      "REPLY_TIME": {
        "NAME": "Customer waiting time",
        "TOOLTIP_TEXT": "Väntetiden är {metricValue} (baserat på {conversationCount} svar)",
        "DESC": ""
      }
    },
    "DATE_RANGE_OPTIONS": {
      "TODAY": "Idag",
      "YESTERDAY": "Igår",
      "LAST_7_DAYS": "De senaste 7 dagarna",
      "LAST_30_DAYS": "De senaste 30 dagarna",
      "THIS_MONTH": "Den här månaden",
      "LAST_MONTH": "Förra månaden",
      "LAST_3_MONTHS": "Last 3 months",
      "LAST_6_MONTHS": "Last 6 months",
      "LAST_YEAR": "Last year",
      "CUSTOM_DATE_RANGE": "Custom date range"
    },
    "CUSTOM_DATE_RANGE": {
      "CONFIRM": "Apply",
      "PLACEHOLDER": "Select date range"
    },
    "GROUP_BY_FILTER_DROPDOWN_LABEL": "Group By",
    "DURATION_FILTER_LABEL": "Duration",
    "GROUPING_OPTIONS": {
      "DAY": "Day",
      "WEEK": "Week",
      "MONTH": "Month",
      "YEAR": "Month"
    },
    "GROUP_BY_DAY_OPTIONS": [
      {
        "id": 1,
        "groupBy": "Day"
      }
    ],
    "GROUP_BY_WEEK_OPTIONS": [
      {
        "id": 1,
        "groupBy": "Day"
      },
      {
        "id": 2,
        "groupBy": "Week"
      }
    ],
    "GROUP_BY_MONTH_OPTIONS": [
      {
        "id": 1,
        "groupBy": "Day"
      },
      {
        "id": 2,
        "groupBy": "Week"
      },
      {
        "id": 3,
        "groupBy": "Month"
      }
    ],
    "GROUP_BY_YEAR_OPTIONS": [
      {
        "id": 1,
        "groupBy": "Day"
      },
      {
        "id": 2,
        "groupBy": "Week"
      },
      {
        "id": 3,
        "groupBy": "Month"
      }
    ],
    "BUSINESS_HOURS": "Öppettider",
    "FILTER_ACTIONS": {
      "CLEAR_FILTER": "Clear filter",
      "EMPTY_LIST": "Inga resultat hittades"
    },
    "DRILLDOWN": {
      "RESULT_COUNT_CONVERSATION": "Konversationer: {count}",
      "RESULT_COUNT_MESSAGE": "Meddelanden: {count}",
      "EMPTY": "Inga poster hittades för den här stapeln.",
      "ERROR": "Posterna kunde inte läsas in. Försök igen.",
      "LOAD_MORE": "Läs in fler",
      "PREVIOUS_BUCKET": "Föregående stapel",
      "NEXT_BUCKET": "Nästa stapel",
      "UNKNOWN_CONTACT": "Okänd kontakt",
      "UNKNOWN_INBOX": "Okänd inkorg",
      "UNASSIGNED_AGENT": "Ej tilldelad",
      "NO_MESSAGE_CONTENT": "Inget meddelandeinnehåll",
      "MESSAGE_CREATED_AT": "Meddelande skapat {time}",
      "EVENT_OCCURRED_AT": "Händelse inträffade {time}",
      "INCOMING_MESSAGE": "Inkommande meddelande",
      "OUTGOING_MESSAGE": "Utgående meddelande",
      "VIEW_ALL": "Visa i konversationer",
      "VIEW_ALL_LIMIT": "Endast staplar med högst {limit} konversationer kan öppnas i konversationslistan.",
      "HIDDEN_COUNT": "Visas inte eftersom du inte är medlem i deras inkorg: {count}"
    },
    "PAGINATION": {
      "RESULTS": "Showing {start} to {end} of {total} results",
      "PER_PAGE_TEMPLATE": "{size} / page"
    }
  },
  "AGENT_REPORTS": {
    "HEADER": "Agents Overview",
    "DESCRIPTION": "Easily track agent performance with key metrics such as conversations, response times, resolution times, and resolved cases. Click an agent’s name to learn more.",
    "LOADING_CHART": "Laddar diagramdata...",
    "NO_ENOUGH_DATA": "Vi har inte fått tillräckligt många datapunkter för att generera en rapport, försök igen senare.",
    "DOWNLOAD_AGENT_REPORTS": "Ladda ner agentrapporter",
    "FILTER_DROPDOWN_LABEL": "Välj agent",
    "METRICS": {
      "CONVERSATIONS": {
        "NAME": "Konversationer",
        "DESC": "( Totalt )"
      },
      "INCOMING_MESSAGES": {
        "NAME": "Inkommande meddelanden",
        "DESC": "( Totalt )"
      },
      "OUTGOING_MESSAGES": {
        "NAME": "Utgående meddelanden",
        "DESC": "( Totalt )"
      },
      "FIRST_RESPONSE_TIME": {
        "NAME": "First Response Time",
        "DESC": "( Genomsnitt )",
        "INFO_TEXT": "Total number of conversations used for computation:",
        "TOOLTIP_TEXT": "First Response Time is {metricValue} (based on {conversationCount} conversations)"
      },
      "RESOLUTION_TIME": {
        "NAME": "Lösningstid",
        "DESC": "( Genomsnitt )",
        "INFO_TEXT": "Total number of conversations used for computation:",
        "TOOLTIP_TEXT": "Resolution Time is {metricValue} (based on {conversationCount} conversations)"
      },
      "RESOLUTION_COUNT": {
        "NAME": "Antal lösta",
        "DESC": "( Totalt )"
      }
    },
    "DATE_RANGE": [
      {
        "id": 0,
        "name": "Senaste 7 dagarna"
      },
      {
        "id": 1,
        "name": "Senaste 30 dagarna"
      },
      {
        "id": 2,
        "name": "Last 3 months"
      },
      {
        "id": 3,
        "name": "Last 6 months"
      },
      {
        "id": 4,
        "name": "Last year"
      },
      {
        "id": 5,
        "name": "Custom date range"
      }
    ],
    "CUSTOM_DATE_RANGE": {
      "CONFIRM": "Apply",
      "PLACEHOLDER": "Select date range"
    }
  },
  "LABEL_REPORTS": {
    "HEADER": "Labels Overview",
    "DESCRIPTION": "Följ etiketternas prestanda med nyckeltal som konversationer, svarstider, lösningstider och lösta ärenden.",
    "LOADING_CHART": "Laddar diagramdata...",
    "NO_ENOUGH_DATA": "Vi har inte fått tillräckligt många datapunkter för att generera en rapport, försök igen senare.",
    "DOWNLOAD_LABEL_REPORTS": "Download label reports",
    "FILTER_DROPDOWN_LABEL": "Select Label",
    "METRICS": {
      "CONVERSATIONS": {
        "NAME": "Konversationer",
        "DESC": "( Totalt )"
      },
      "INCOMING_MESSAGES": {
        "NAME": "Inkommande meddelanden",
        "DESC": "( Totalt )"
      },
      "OUTGOING_MESSAGES": {
        "NAME": "Utgående meddelanden",
        "DESC": "( Totalt )"
      },
      "FIRST_RESPONSE_TIME": {
        "NAME": "First Response Time",
        "DESC": "( Genomsnitt )",
        "INFO_TEXT": "Total number of conversations used for computation:",
        "TOOLTIP_TEXT": "First Response Time is {metricValue} (based on {conversationCount} conversations)"
      },
      "RESOLUTION_TIME": {
        "NAME": "Lösningstid",
        "DESC": "( Genomsnitt )",
        "INFO_TEXT": "Total number of conversations used for computation:",
        "TOOLTIP_TEXT": "Resolution Time is {metricValue} (based on {conversationCount} conversations)"
      },
      "RESOLUTION_COUNT": {
        "NAME": "Antal lösta",
        "DESC": "( Totalt )"
      }
    },
    "DATE_RANGE": [
      {
        "id": 0,
        "name": "Senaste 7 dagarna"
      },
      {
        "id": 1,
        "name": "Senaste 30 dagarna"
      },
      {
        "id": 2,
        "name": "Last 3 months"
      },
      {
        "id": 3,
        "name": "Last 6 months"
      },
      {
        "id": 4,
        "name": "Last year"
      },
      {
        "id": 5,
        "name": "Custom date range"
      }
    ],
    "CUSTOM_DATE_RANGE": {
      "CONFIRM": "Apply",
      "PLACEHOLDER": "Select date range"
    }
  },
  "INBOX_REPORTS": {
    "HEADER": "Inbox Overview",
    "DESCRIPTION": "Quickly view your inbox performance with key metrics like conversations, response times, resolution times, and resolved cases—all in one place. Click an inbox name for more details.",
    "LOADING_CHART": "Laddar diagramdata...",
    "NO_ENOUGH_DATA": "Vi har inte fått tillräckligt många datapunkter för att generera en rapport, försök igen senare.",
    "DOWNLOAD_INBOX_REPORTS": "Download inbox reports",
    "FILTER_DROPDOWN_LABEL": "Select Inbox",
    "METRICS": {
      "CONVERSATIONS": {
        "NAME": "Konversationer",
        "DESC": "( Totalt )"
      },
      "INCOMING_MESSAGES": {
        "NAME": "Inkommande meddelanden",
        "DESC": "( Totalt )"
      },
      "OUTGOING_MESSAGES": {
        "NAME": "Utgående meddelanden",
        "DESC": "( Totalt )"
      },
      "FIRST_RESPONSE_TIME": {
        "NAME": "First Response Time",
        "DESC": "( Genomsnitt )",
        "INFO_TEXT": "Total number of conversations used for computation:",
        "TOOLTIP_TEXT": "First Response Time is {metricValue} (based on {conversationCount} conversations)"
      },
      "RESOLUTION_TIME": {
        "NAME": "Lösningstid",
        "DESC": "( Genomsnitt )",
        "INFO_TEXT": "Total number of conversations used for computation:",
        "TOOLTIP_TEXT": "Resolution Time is {metricValue} (based on {conversationCount} conversations)"
      },
      "RESOLUTION_COUNT": {
        "NAME": "Antal lösta",
        "DESC": "( Totalt )"
      }
    },
    "DATE_RANGE": [
      {
        "id": 0,
        "name": "Senaste 7 dagarna"
      },
      {
        "id": 1,
        "name": "Senaste 30 dagarna"
      },
      {
        "id": 2,
        "name": "Last 3 months"
      },
      {
        "id": 3,
        "name": "Last 6 months"
      },
      {
        "id": 4,
        "name": "Senaste året"
      },
      {
        "id": 5,
        "name": "Custom date range"
      }
    ],
    "CUSTOM_DATE_RANGE": {
      "CONFIRM": "Apply",
      "PLACEHOLDER": "Select date range"
    }
  },
  "TEAM_REPORTS": {
    "HEADER": "Team Overview",
    "DESCRIPTION": "Get a snapshot of your team’s performance with essential metrics, including conversations, response times, resolution times, and resolved cases. Click a team name for more details.",
    "LOADING_CHART": "Laddar diagramdata...",
    "NO_ENOUGH_DATA": "Vi har inte fått tillräckligt många datapunkter för att generera en rapport, försök igen senare.",
    "DOWNLOAD_TEAM_REPORTS": "Download team reports",
    "FILTER_DROPDOWN_LABEL": "Select Team",
    "METRICS": {
      "CONVERSATIONS": {
        "NAME": "Konversationer",
        "DESC": "( Totalt )"
      },
      "INCOMING_MESSAGES": {
        "NAME": "Inkommande meddelanden",
        "DESC": "( Totalt )"
      },
      "OUTGOING_MESSAGES": {
        "NAME": "Utgående meddelanden",
        "DESC": "( Totalt )"
      },
      "FIRST_RESPONSE_TIME": {
        "NAME": "First Response Time",
        "DESC": "( Genomsnitt )",
        "INFO_TEXT": "Total number of conversations used for computation:",
        "TOOLTIP_TEXT": "First Response Time is {metricValue} (based on {conversationCount} conversations)"
      },
      "RESOLUTION_TIME": {
        "NAME": "Lösningstid",
        "DESC": "( Genomsnitt )",
        "INFO_TEXT": "Total number of conversations used for computation:",
        "TOOLTIP_TEXT": "Resolution Time is {metricValue} (based on {conversationCount} conversations)"
      },
      "RESOLUTION_COUNT": {
        "NAME": "Antal lösta",
        "DESC": "( Totalt )"
      }
    },
    "DATE_RANGE": [
      {
        "id": 0,
        "name": "Senaste 7 dagarna"
      },
      {
        "id": 1,
        "name": "Senaste 30 dagarna"
      },
      {
        "id": 2,
        "name": "De senaste 3 månaderna"
      },
      {
        "id": 3,
        "name": "De senaste 6 månaderna"
      },
      {
        "id": 4,
        "name": "Senaste året"
      },
      {
        "id": 5,
        "name": "Custom date range"
      }
    ],
    "CUSTOM_DATE_RANGE": {
      "CONFIRM": "Apply",
      "PLACEHOLDER": "Select date range"
    }
  },
  "CSAT_REPORTS": {
    "HEADER": "CSAT Reports",
    "NO_RECORDS": "There are no CSAT survey responses available.",
    "DOWNLOAD": "Download CSAT Reports",
    "DOWNLOAD_FAILED": "Failed to download CSAT Reports",
    "FILTERS": {
      "AGENTS": {
        "PLACEHOLDER": "Choose Agents"
      }
    },
    "TABLE": {
      "HEADER": {
        "CONTACT_NAME": "Contact",
        "AGENT_NAME": "Assigned agent",
        "RATING": "Betyg",
        "FEEDBACK_TEXT": "Feedback comment"
      }
    },
    "METRIC": {
      "TOTAL_RESPONSES": {
        "LABEL": "Total responses",
        "TOOLTIP": "Total number of responses collected"
      },
      "SATISFACTION_SCORE": {
        "LABEL": "Satisfaction score",
        "TOOLTIP": "Total number of positive responses / Total number of responses * 100"
      },
      "RESPONSE_RATE": {
        "LABEL": "Response rate",
        "TOOLTIP": "Total number of responses / Total number of CSAT survey messages sent * 100"
      }
    }
  },
  "BOT_REPORTS": {
    "HEADER": "Bot Reports",
    "METRIC": {
      "CONVERSATION_COUNT": {
        "LABEL": "Antal konversationer",
        "TOOLTIP": "Totalt antal konversationer med botmeddelanden"
      },
      "OUTGOING_COUNT": {
        "LABEL": "Antal svar",
        "TOOLTIP": "Totalt antal utgående meddelanden"
      },
      "MESSAGE_COUNT": {
        "LABEL": "Antal AI-svar",
        "TOOLTIP": "Totalt antal svarsmeddelanden som skickats av boten"
      },
      "COPILOT_COUNT": {
        "LABEL": "Antal förberedda svar",
        "TOOLTIP": "Totalt antal copilot-förslag förberedda av boten för agenter"
      },
      "SUCCESS_RATE": {
        "LABEL": "Löst av AI",
        "TOOLTIP": "Andel konversationer som lösts av AI utan att överlämnas till en agent"
      },
      "RESOLVE_TIME": {
        "LABEL": "Lösningstid",
        "TOOLTIP": "Medianvärde för tiden från kundens första meddelande till botens/agentens sista meddelande"
      },
      "TOTAL_CONVERSATIONS": {
        "LABEL": "No. of Conversations",
        "TOOLTIP": "Total number of conversations handled by the bot"
      },
      "TOTAL_RESPONSES": {
        "LABEL": "Total Responses",
        "TOOLTIP": "Total number of responses sent by the bot"
      },
      "RESOLUTION_RATE": {
        "LABEL": "Resolution Rate",
        "TOOLTIP": "Total number of conversations resolved by the bot / Total number of conversations handled by the bot * 100"
      },
      "HANDOFF_RATE": {
        "LABEL": "Handoff Rate",
        "TOOLTIP": "Total number of conversations handed off to agents / Total number of conversations handled by the bot * 100"
      }
    },
    "GROUP_BY": {
      "NONE": "Gruppera inte",
      "INBOXES": "Inkorgar",
      "LABELS": "Etiketter"
    },
    "GROUPED": {
      "CHART_TITLE": "Fördelning per grupp",
      "BACK_TO_ALL": "Visa alla",
      "TABLE": {
        "INBOX": "Inkorg",
        "LABEL": "Etikett",
        "CONVERSATIONS": "Konversationer",
        "MESSAGES": "Meddelanden",
        "MESSAGES_TOOLTIP": "Totalt antal utgående meddelanden",
        "AI_MESSAGES": "AI-svar",
        "AI_MESSAGES_TOOLTIP": "Totalt antal AI-svar, följt av antalet positiva och negativa betyg från slutanvändare",
        "THUMBS_UP_TOOLTIP": "Antal AI-svar som fått positivt betyg (tumme upp) av slutanvändare",
        "THUMBS_DOWN_TOOLTIP": "Antal AI-svar som fått negativt betyg (tumme ner) av slutanvändare",
        "PREPARED": "Förberedda svar",
        "PERCENTAGE": "%",
        "PERCENTAGE_TOOLTIP": "Andel meddelanden av alla meddelanden som tillhör den här gruppen",
        "BOT_RESPONSES": "AI-svar %",
        "SUGGESTION_USED": "Använda svar",
        "SUGGESTION_USED_TOOLTIP": "Andel förberedda svar i den här gruppen som användes av agenter",
        "SUGGESTION_NOT_USED": "Oanvända svar",
        "SUGGESTION_NOT_USED_TOOLTIP": "Andel meddelanden i den här gruppen som hade ett förberett svar som inte användes"
      },
      "NOTES": {
        "TITLE": "Hur mätvärden beräknas",
        "CONVERSATIONS": "Antal konversationer som har minst ett utgående meddelande under den valda perioden.",
        "MESSAGES": "Totalt antal utgående (icke-privata) meddelanden som skickats under den valda perioden. Detta inkluderar både AI-genererade och mänskligt skrivna meddelanden.",
        "PERCENTAGE": "Andel av den här gruppens meddelanden av alla utgående meddelanden i alla grupper.",
        "AI_MESSAGES": "Antal utgående meddelanden som skickats automatiskt av AI-boten (exklusive förberedda svar för agenter). Siffrorna inom parentes visar hur många av dessa svar som fått positivt betyg (tumme upp) respektive negativt betyg (tumme ner) av slutanvändare.",
        "PREPARED": "Antal copilot-förslag (förberedda svar) som genererats av AI-boten för agenter under den valda perioden. Dessa är privata meddelanden som bara är synliga för agenter och räknas inte som utgående meddelanden, så det här talet kanske inte stämmer överens med kolumnen Meddelanden.",
        "SUGGESTION_USED": "Andel förberedda svar i den här gruppen som användes av agenter. Detta kanske inte stämmer överens med antalet i kolumnen Förberedda svar eftersom det även kan inkludera förslag som genererats under tidigare perioder.",
        "SUGGESTION_NOT_USED": "Andel utgående meddelanden i den här gruppen där ett copilot-förslag fanns tillgängligt men agenten svarade utan att använda det. Räknas endast när agenten faktiskt skickade ett svar. Detta kanske inte stämmer överens med antalet i kolumnen Förberedda svar eftersom det även kan inkludera förslag som genererats under tidigare perioder."
      }
    }
  },
  "OVERVIEW_REPORTS": {
    "HEADER": "Overview",
    "LIVE": "Live",
    "ACCOUNT_CONVERSATIONS": {
      "HEADER": "Open Conversations",
      "LOADING_MESSAGE": "Loading conversation metrics...",
      "OPEN": "Öppna",
      "UNATTENDED": "Unattended",
      "UNASSIGNED": "Otilldelade",
      "PENDING": "Väntande"
    },
    "CONVERSATION_HEATMAP": {
      "HEADER": "Conversation Traffic",
      "NO_CONVERSATIONS": "No conversations",
      "CONVERSATION": "{count} conversation",
      "CONVERSATIONS": "{count} conversations",
      "DOWNLOAD_REPORT": "Download report"
    },
    "AGENT_CONVERSATIONS": {
      "HEADER": "Conversations by agents",
      "LOADING_MESSAGE": "Loading agent metrics...",
      "NO_AGENTS": "There are no conversations by agents",
      "TABLE_HEADER": {
        "AGENT": "Agent",
        "OPEN": "Öppna",
        "UNATTENDED": "Unattended",
        "STATUS": "Status"
      }
    },
    "TEAM_CONVERSATIONS": {
      "ALL_TEAMS": "All Teams",
      "HEADER": "Conversations by teams",
      "LOADING_MESSAGE": "Loading team metrics...",
      "NO_TEAMS": "There is no data available",
      "TABLE_HEADER": {
        "TEAM": "Team",
        "OPEN": "Öppna",
        "UNATTENDED": "Unattended",
        "STATUS": "Status"
      }
    },
    "AGENT_STATUS": {
      "HEADER": "Agent status",
      "ONLINE": "Online",
      "BUSY": "Upptagen",
      "OFFLINE": "Offline"
    }
  },
  "DAYS_OF_WEEK": {
    "SUNDAY": "Sunday",
    "MONDAY": "Monday",
    "TUESDAY": "Tuesday",
    "WEDNESDAY": "Wednesday",
    "THURSDAY": "Thursday",
    "FRIDAY": "Friday",
    "SATURDAY": "Saturday"
  },
  "SLA_REPORTS": {
    "HEADER": "SLA Reports",
    "NO_RECORDS": "SLA applied conversations are not available.",
    "LOADING": "Loading SLA data...",
    "DOWNLOAD_SLA_REPORTS": "Download SLA reports",
    "DOWNLOAD_FAILED": "Failed to download SLA Reports",
    "DROPDOWN": {
      "ADD_FIlTER": "Add filter",
      "CLEAR_ALL": "Clear all",
      "CLEAR_FILTER": "Clear filter",
      "EMPTY_LIST": "Inga resultat hittades",
      "NO_FILTER": "No filters available",
      "SEARCH": "Search filter",
      "INPUT_PLACEHOLDER": {
        "SLA": "SLA name",
        "AGENTS": "Agent name",
        "INBOXES": "Inbox name",
        "LABELS": "Etikettnamn",
        "TEAMS": "Team name"
      },
      "SLA": "SLA Policy",
      "INBOXES": "Inkorg",
      "AGENTS": "Agent",
      "LABELS": "Label",
      "TEAMS": "Team"
    },
    "WITH": "with",
    "METRICS": {
      "HIT_RATE": {
        "LABEL": "Hit Rate",
        "TOOLTIP": "Percentage of SLAs created were completed successfully"
      },
      "NO_OF_MISSES": {
        "LABEL": "Number of Misses",
        "TOOLTIP": "Total SLA misses in a certain period"
      },
      "NO_OF_CONVERSATIONS": {
        "LABEL": "Number of Conversations",
        "TOOLTIP": "Total number of conversations with SLA"
      }
    },
    "TABLE": {
      "HEADER": {
        "POLICY": "Policy",
        "CONVERSATION": "Conversation",
        "AGENT": "Agent"
      },
      "VIEW_DETAILS": "View Details"
    }
  },
  "SUMMARY_REPORTS": {
    "SUBTOTAL": "Delsumma",
    "NO_TEAM": "Inget team",
    "GROUP_BY_TEAMS": "Gruppera efter team",
    "INBOX": "Inkorg",
    "AGENT": "Agent",
    "TEAM": "Team",
    "LABEL": "Etikett",
    "TOTAL": "Totalt",
    "AVG_RESOLUTION_TIME": "Avg. Resolution Time",
    "AVG_FIRST_RESPONSE_TIME": "Avg. First Response Time",
    "AVG_REPLY_TIME": "Avg. Customer Waiting Time",
    "RESOLUTION_COUNT": "Antal lösta",
    "CONVERSATIONS": "No. of conversations",
    "OUTGOING_CHATS": "Utgående chattar",
    "OUTGOING_EMAILS": "Utgående e-post",
    "PHONE_CALLS": "Telefonsamtal",
    "INBOUND_CALLS": "Inkommande samtal",
    "OUTBOUND_CALLS": "Utgående samtal",
    "TOTAL_ACTIVITIES": "Totalt antal aktiviteter",
    "ONLINE_TIME": "Onlinetid",
    "QUEUE_AVAILABLE_TIME": "Tillgänglighetstid i kö",
    "TOOLTIPS": {
      "OUTGOING_CHATS": "Antal utgående meddelanden som skickats av den här agenten",
      "OUTGOING_EMAILS": "Antal utgående e-postmeddelanden som skickats av den här agenten",
      "PHONE_CALLS": "Totalt antal telefonsamtal tilldelade den här agenten (summan av inkommande och utgående samtal)",
      "TOTAL_ACTIVITIES": "Totalt antal aktiviteter: inkommande samtal + utgående samtal + utgående chattar + utgående e-post",
      "INBOUND_CALLS": "Antal inkommande telefonsamtal tilldelade den här agenten",
      "OUTBOUND_CALLS": "Antal utgående telefonsamtal tilldelade den här agenten",
      "AVG_FIRST_RESPONSE_TIME": "Genomsnittlig tid från konversationens skapande till agentens första svar i konversationer tilldelade den här agenten",
      "AVG_RESOLUTION_TIME": "Genomsnittlig tid från konversationens skapande till lösning i konversationer tilldelade den här agenten",
      "AVG_REPLY_TIME": "Genomsnittlig tid kunder väntar mellan sitt meddelande och agentens svar i konversationer tilldelade den här agenten",
      "ONLINE_TIME": "Total tid agenten var online eller upptagen under den valda perioden",
      "QUEUE_AVAILABLE_TIME": "Total tid agenten var tillgänglig i telefonköer under den valda perioden"
    }
  },
  "PHONE_REPORTS": {
    "HEADER": "Telefonrapporter",
    "DESCRIPTION": "Följ telefonsamtalsmått med detaljerade insikter om inkommande och utgående samtal, grupperade efter agent eller inkorg för en heltäckande analys.",
    "DOWNLOAD_PHONE_REPORTS": "Ladda ner telefonrapporter",
    "GROUP_BY": {
      "LABEL": "Gruppera efter",
      "AGENT": "Agent",
      "INBOX": "Inkorg"
    },
    "TABLE": {
      "TOTAL_CALLS": "Totalt",
      "INBOUND_CALLS": "Inkommande",
      "OUTBOUND_CALLS": "Utgående",
      "FAILED_OUTBOUND_CALLS": "Misslyckade utgående",
      "AVG_AGENT_HANDLED_DURATION": "Genomsnittlig varaktighet",
      "TOTAL_AGENT_HANDLED_DURATION": "Total varaktighet",
      "AVG_RINGING_TIME": "Genomsnittlig ringtid",
      "CONNECTED_OUTBOUND_PERCENTAGE": "Framgång %",
      "UNIQUE_CALLERS": "Unika uppringare",
      "UNIQUE_CALLED_CONTACTS": "Unika uppringda",
      "UNANSWERED_MISSED_CALLS": "Missat utan uppföljning",
      "UNANSWERED_MISSED_PERCENTAGE": "Obesvarat missat %",
      "INSUFFICIENTLY_HANDLED_UNANSWERED_MISSED_CALLS": "Missat utan uppföljning, otillräckligt återuppringt",
      "INSUFFICIENTLY_HANDLED_UNANSWERED_MISSED_PERCENTAGE": "Missat utan uppföljning, otillräckligt återuppringt %"
    },
    "TOOLTIPS": {
      "TOTAL_CALLS": "Totalt antal alla samtal (inklusive ej anslutna)",
      "INBOUND_CALLS": "Antal anslutna samtal",
      "OUTBOUND_CALLS": "Antal alla utgående samtal (inklusive ej anslutna)",
      "FAILED_OUTBOUND_CALLS": "Antal utgående samtal som misslyckades med att ansluta",
      "AVG_AGENT_HANDLED_DURATION": "Genomsnittlig varaktighet för samtal hanterade av agenter",
      "TOTAL_AGENT_HANDLED_DURATION": "Total varaktighet för alla samtal hanterade av agenter",
      "AVG_RINGING_TIME": "Genomsnittlig tid samtal ringde innan de besvarades",
      "CONNECTED_OUTBOUND_PERCENTAGE": "Andel utgående samtal som anslöts framgångsrikt",
      "UNIQUE_CALLERS": "Antal unika kontakter som ringde inkommande samtal",
      "UNIQUE_CALLED_CONTACTS": "Antal unika kontakter som ringdes upp via utgående samtal",
      "UNANSWERED_MISSED_CALLS": "Antal missade samtal där ingen lyckad återuppringning gjordes (samtalet anslöts). Kan inkludera samtal som fortfarande kan hanteras under arbetsdagen",
      "UNANSWERED_MISSED_PERCENTAGE": "Andel unika uppringare vars samtal missades utan uppföljning (obesvarade missade samtal / unika uppringare)",
      "INSUFFICIENTLY_HANDLED_UNANSWERED_MISSED_CALLS": "Antal missade samtal med färre än 2 återuppringningsförsök. Kan inkludera samtal som fortfarande kan hanteras under arbetsdagen",
      "INSUFFICIENTLY_HANDLED_UNANSWERED_MISSED_PERCENTAGE": "Andel unika uppringare med färre än 2 återuppringningsförsök ((missat utan uppföljning - tillräckligt hanterat) / unika uppringare)"
    }
  }
}
